/**
 * Close-code / matchmaker-error classification for the in-session reconnect
 * loop (LobbySession.handleLeave / tryReconnect). Numeric values verified
 * against colyseus.js 0.16.22 (`lib/errors/Errors.ts` CloseCode,
 * `lib/Protocol.ts` ErrorCode) — CloseCode is not re-exported from the
 * package root, so the literal is pinned here. Pure, mirroring
 * classifyJoinError.
 */

/**
 * CloseCode.CONSENTED. The server closed the socket on purpose — kick,
 * rate-limit disconnect (hardened-transport.ts `socket.close(4000)`),
 * redeploy — which routes through `onLeave(client, consented: true)` and
 * hard-deletes the seat with no allowReconnection grace window. The
 * reconnection token is dead on arrival.
 */
const WS_CLOSE_CONSENTED = 4000;

export function isConsentedClose(code: number): boolean {
  return code === WS_CLOSE_CONSENTED;
}

/**
 * Matchmaker rejections that are deterministic for a given token:
 * 4214 MATCHMAKE_EXPIRED ("reconnection token invalid or expired" — the seat
 * was hard-deleted in Lobby/GameEnd, or the TTL lapsed) and 4212
 * MATCHMAKE_INVALID_ROOM_ID ("room has been disposed"). Retrying the same
 * token cannot succeed; the only way back in is a fresh joinOrCreate.
 */
const MATCHMAKE_INVALID_ROOM_ID = 4212;
const MATCHMAKE_EXPIRED = 4214;

export function isDeadTokenError(err: unknown): boolean {
  const code = (err as { code?: unknown } | null | undefined)?.code;
  return code === MATCHMAKE_INVALID_ROOM_ID || code === MATCHMAKE_EXPIRED;
}
